import { __extends } from "tslib";
import { Plugin, } from 'prosemirror-state';
import { startMeasure, stopMeasure } from '@atlaskit/editor-common';
var InstrumentedPlugin = /** @class */ (function (_super) {
    __extends(InstrumentedPlugin, _super);
    function InstrumentedPlugin(spec) {
        var _this = this;
        if (spec.state) {
            var originalApply_1 = spec.state.apply.bind(spec.state);
            spec.state.apply = function (tr, value, oldState, newState) {
                var self = _this;
                var measure = "\uD83E\uDD89" + self.key + "::apply";
                startMeasure(measure);
                var result = originalApply_1(tr, value, oldState, newState);
                stopMeasure(measure, function () { });
                return result;
            };
        }
        if (spec.view) {
            var originalView_1 = spec.view.bind(spec);
            spec.view = function (editorView) {
                var self = _this;
                var measure = "\uD83E\uDD89" + self.key + "::view::update";
                var view = originalView_1(editorView);
                if (view.update) {
                    var originalUpdate_1 = view.update;
                    view.update = function (view, state) {
                        startMeasure(measure);
                        originalUpdate_1(view, state);
                        stopMeasure(measure, function () { });
                    };
                }
                return view;
            };
        }
        _this = _super.call(this, spec) || this;
        return _this;
    }
    InstrumentedPlugin.fromPlugin = function (plugin) {
        return new InstrumentedPlugin(plugin.spec);
    };
    return InstrumentedPlugin;
}(Plugin));
export { InstrumentedPlugin };
//# sourceMappingURL=instrumented-plugin.js.map